import { BookOpenCheck, Sparkles } from "lucide-react";

export default function Header({ planCount, onOpenAi }) {
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 h-[72px] flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-indigo-600 flex items-center justify-center">
            <BookOpenCheck className="h-5 w-5 text-white" />
          </div>
          <div>
            <p className="font-display text-lg font-black text-slate-900 leading-tight" data-testid="app-title">Boravko</p>
            <p className="text-xs font-medium text-slate-500 leading-tight">Riznica ideja za produženi boravak</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button
            data-testid="header-ai-btn"
            onClick={onOpenAi}
            className="hidden sm:inline-flex items-center gap-2 rounded-full border border-indigo-200 bg-indigo-50 px-4 py-2 text-sm font-semibold text-indigo-700 hover:bg-indigo-100 transition-colors duration-200"
          >
            <Sparkles className="h-4 w-4" /> AI asistent
          </button>
          <div
            data-testid="header-plan-count"
            className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700"
          >
            Tjedni plan
            <span className="inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-indigo-600 px-1.5 text-xs font-bold text-white">
              {planCount}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
